<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WidgetIntArticlesSettings'
});

interface FormSettings
{
    settings: any;
}

const props = defineProps<{
    modelValue: any;
}>();
const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const module = ref('articles');
const defaults = ref<any>({
    page: null,
    widgetOption: '0',
    quantity: 3
});

const form = computed<FormType<FormSettings>>(() =>
{
    return props.modelValue;
});

const quantity = computed<Option<number>[]>(() =>
{
    return new Array(10).fill(null).map((value, index) =>
    {
        return { value: index + 1, text: (index + 1).toString() };
    });
});

const displayOptions = computed<Option[]>(() =>
{
    return [
        { value: '0', text: $t('[[[Wszystkie]]]') },
        { value: '1', text: $t('[[[Tylko ze zdjęciami]]]') },
        { value: '2', text: $t('[[[Bez zdjęć]]]') }
    ];
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({
            page: schema.string().nullable().required($t('[[[Wybranie strony jest wymagane]]]'))
        })
    }));
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});

defineExpose({
    validate
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Artykuły ze strony]]]')" :invalid-feedback="form.$errors.first('settings.page')" :state="form.$errors.state('settings.page')" required>
        <EditoPageSelector
            v-model="form.settings.page"
            :module="module"
            :website-id="form.websiteId"
            :locale="form.locale"
            label=""
            :website="false"
            :preview="false"
            class="mb-0"
        />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Ilość wyświetlanych artykułów]]]')" :invalid-feedback="form.$errors.first('settings.quantity')" :state="form.$errors.state('settings.quantity')">
        <IdeoFormSelect v-model="form.settings.quantity" name="settings.quantity" :options="quantity" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Typ wyświetlanych artykułów]]]')" :invalid-feedback="form.$errors.first('settings.widgetOption')" :state="form.$errors.state('settings.widgetOption')">
        <IdeoFormSelect v-model="form.settings.widgetOption" :options="displayOptions" />
    </IdeoFormGroup>
</template>
